import { TournamentDistributionType, TournamentPayoutType } from '@okletsplay/core';

const BASE_DEFAULT_VALUES = {
  name: '',
  passphrase: '',
  teamsSettings: {
    teamSize: 0,
    minTeams: 0,
    maxTeams: 0,
  },
  matchSetupSettings: {
    eliminationFormat: '',
  },
  prizeAndDistribution: {
    isDistributedExternally: false,
    seedAmount: 0,
    playerEntryFee: 0,
    hostFeesPercentage: 25,
    payoutType: TournamentPayoutType.RankPosition,
    lastWinningPosition: 1,
    thresholdPercentage: 10,
    distributionType: TournamentDistributionType.AutomaticTiers,
    distributionBreakdown: [],
    manualWeights: [],
  },
};

export const ASYNC_TOURNAMENT_DEFAULT_VALUES = BASE_DEFAULT_VALUES;

export const KNOCKOUT_TOURNAMENT_DEFAULT_VALUES = {
  ...BASE_DEFAULT_VALUES,
  startedAt: new Date(),
  subMatchesSettings: [],
};

export const LOL_TOURNAMENT_DEFAULT_VALUES = {
  ...KNOCKOUT_TOURNAMENT_DEFAULT_VALUES,
  spectators: [],
};

export const DEFAULT_EDIT_FORM_VALUES = {
  name: '',
  passphrase: '',
  teamsSettings: {
    teamSize: 0,
    minTeams: 0,
    maxTeams: 0,
  },
  matchSetupSettings: {
    eliminationFormat: '',
  },
  prizeAndDistribution: {
    isDistributedExternally: false,
    seedAmount: 0,
    playerEntryFee: 0,
    hostFeesPercentage: 25,
    payoutType: TournamentPayoutType.RankPosition,
    lastWinningPosition: 1,
    thresholdPercentage: 10,
    distributionType: TournamentDistributionType.AutomaticTiers,
    distributionBreakdown: [],
    manualWeights: [],
  },
  startedAt: new Date(),
  subMatchesSettings: [],
  spectators: [],
};
